(function () {
    angular.module('tmx-app').controller('organizationsEditCtrl', ['$state', 'OrganizationsService', 'resolvedData', '$anchorScroll', '$location', 'tmxUtility', 'TmxDialogService','lookupService', 'BranchService', 

        function OrganizationsEditCtrl($state, OrganizationsService, resolvedData, $anchorScroll, $location, tmxUtility, TmxDialogService,lookupService, BranchService) {

            var organizationVM = this;
            organizationVM.TENANTID = 1;
            organizationVM.vm = new OrganizationsService();
            organizationVM.dataLoading = false;
            organizationVM.formSubmitted = false;
            organizationVM.vm.TmxUnitContactPerson = [];
            if ($state.params && $state.params.Id)
                organizationVM.isEdit = true;
            else
                organizationVM.isEdit = false;
            if ($state.params && $state.params.readOnly && $state.params.readOnly == true)
                organizationVM.readonly = true;
            else
                organizationVM.readonly = false;
            organizationVM.OrganizationStatusCode = false;
            organizationVM.Loading = false;
            organizationVM.vm.SABankAccounts = [];
            organizationVM.vm.SAContactPersons = [];
            organizationVM.vm.SADocuments = [];
            organizationVM.tempSADocuments = [];
            organizationVM.tempSABankAccounts = [];
            organizationVM.tempSAContactPersons = [];
            organizationVM.tempRelationMapping = [];
            organizationVM.isInFoPage = false;
            organizationVM.save = save;
            organizationVM.StatusLkp = resolvedData.OrganizationStatus;
            organizationVM.Industry = resolvedData.OrganizationIndustry;
            organizationVM.OrgType = resolvedData.OrganizationType;
            organizationVM.StatusLkp1 = resolvedData.OrganizationRelations;
            organizationVM.setActiveFlag = setActiveFlag;
            organizationVM.gotoAnchor = gotoAnchor;
            organizationVM.cancel = cancel;
            organizationVM.status = status;
            organizationVM.checkOrganizationCode = checkOrganizationCode;
            organizationVM.findWithAttr = findWithAttr;
            organizationVM.addAccount = addAccount;
            organizationVM.addDetails = addDetails;
            organizationVM.addMapping = addMapping;
            organizationVM.deleteSection = deleteSection;
            organizationVM.addDocuments = addDocuments;
            organizationVM.deleteSection = deleteSection;
            organizationVM.deleteAccount = deleteAccount;
            organizationVM.deleteMapping = deleteMapping;
            organizationVM.fetchDetails = fetchDetails;
            organizationVM.deleteDetails = deleteDetails;
            organizationVM.deleteDocuments = deleteDocuments;
            organizationVM.response = [];
            organizationVM.formValidation = formValidation;
            organizationVM.Filename = null;
            organizationVM.gridData = resolvedData.activeLocations;
            organizationVM.uploadShow = false;
            organizationVM.Companies = resolvedData.Company.data;
            organizationVM.Branches=[];
            var showConfirmDialog = TmxDialogService.showConfirmDialog;
            organizationVM.afterImport = afterImport;
            organizationVM.allCustomers = resolvedData.activeCustomers.data.map(x => {
                return {
                    CustomerMasterId: x.CustomerMasterId,
                    CustomerName: x.CustomerName
                }
            });
            organizationVM.RelationMapping = [];

            organizationVM.updateBranches = function (stateId) {
                if ((!(angular.isDefined(stateId)) || stateId === null)) {
                    organizationVM.vm.CompanyBranchId = null;
                    return;
                }


                BranchService.CompanyBranchLov(stateId).then(
                    function (data) {
                        organizationVM.Branches = data.data;
                    }
                );
            }
            organizationVM.getCompanyAndItsBranch = function (BranchId) {

                BranchService.getCompanyByBranchId(BranchId).then(
                    function (data) {
                        if (angular.isDefined(data)) {
                            organizationVM.vm.CompanyId = data.data.CompanyId;
                        }

                    });
            };


            function addAccount() {
                var Account = {

                    BankAccountNumber: ""
                }
                if (!organizationVM.vm.TmXCustomerBankingDetails)
                    organizationVM.vm.TmXCustomerBankingDetails = [];
                organizationVM.vm.TmXCustomerBankingDetails.push(Account);


            }
       
            function deleteAccount(index) {
                showConfirmDialog("Confirmation", "Are you sure you want to remove this Account", function () {
                    organizationVM.vm.TmXCustomerBankingDetails[index].CustomerBankingDetailsId = parseInt(organizationVM.vm.TmXCustomerBankingDetails[index].CustomerBankingDetailsId) * (-1);
                    organizationVM.tempSABankAccounts.push(organizationVM.vm.TmXCustomerBankingDetails[index]);
                    organizationVM.vm.TmXCustomerBankingDetails.splice(index, 1);
                });
            }

            function fetchDetails(id) {
                OrganizationsService.geDetailsByCIF(id).then(function (result) {
                    organizationVM.vm = result.data;
                });
            }

            function addDetails() {
                var Details = {

                    Name: "",
                    Phone: "",
                    Email: ""

                };
                if (!organizationVM.vm.TmXOrganizationContactPersons)
                    organizationVM.vm.TmXOrganizationContactPersons = [];
                organizationVM.vm.TmXOrganizationContactPersons.push(Details);

            }
            function addMapping() {
                var Details = {

                    tempOrganizationRelationMapping: [],
                    RelationStatusLkpId:0

                };
                if (!organizationVM.RelationMapping)
                    organizationVM.RelationMapping = [];
                organizationVM.RelationMapping.push(Details);

            }

            function deleteDetails(index) {
                showConfirmDialog("Confirmation", "Are you sure you want to remove this Detail?", function () {
                    organizationVM.vm.TmXOrganizationContactPersons[index].OrganizationContactPersonId = parseInt(organizationVM.vm.TmXOrganizationContactPersons[index].OrganizationContactPersonId) * (-1);
                    organizationVM.tempSAContactPersons.push(organizationVM.vm.TmXOrganizationContactPersons[index]);
                    organizationVM.vm.TmXOrganizationContactPersons.splice(index, 1);
                });
            }
            function deleteMapping(index) {
                showConfirmDialog("Confirmation", "Are you sure you want to remove this Detail?", function () {
                    if(organizationVM.vm.TmXCustomerOrganizationRelationMapping[index].CustomerToOrganizationRelationMapping && organizationVM.vm.TmXCustomerOrganizationRelationMapping[index].CustomerToOrganizationRelationMapping>0){
                        var relation = organizationVM.vm.TmXCustomerOrganizationRelationMapping[index].RelationStatusLkpId;
                        for(var i=0;i<organizationVM.vm.TmXCustomerOrganizationRelationMapping.length;i++) {
                            if(organizationVM.vm.TmXCustomerOrganizationRelationMapping[i].RelationStatusLkpId == relation)
                                organizationVM.vm.TmXCustomerOrganizationRelationMapping[i].CustomerToOrganizationRelationMapping = parseInt(organizationVM.vm.TmXCustomerOrganizationRelationMapping[i].CustomerToOrganizationRelationMapping) * (-1);
                            organizationVM.tempRelationMapping.push(organizationVM.vm.TmXCustomerOrganizationRelationMapping[i]);
                            organizationVM.vm.TmXCustomerOrganizationRelationMapping.splice(i, 1);
                        }
                        organizationVM.RelationMapping.splice(index,1);
                
                    }
                    else
                        organizationVM.RelationMapping.splice(index, 1);
                });
            }
            function afterImport(response) {

                if (response.data.status.code == 200) {

                    organizationVM.uploadShow = true;
                    organizationVM.vm.FilePath = response.data.data;
                    showCustomToast("success", "Upload Successful");
                }

            }


            function addDocuments() {
                var Documents = {

                    Name: null,
                    Type: null,
                    DocumentDate: null,
                    FileName: null

                };
                if (!organizationVM.vm.SADocuments)
                    organizationVM.vm.SADocuments = [];
                organizationVM.vm.SADocuments.push(Documents);

            }

            function deleteDocuments(index) {
                showConfirmDialog("Confirmation", "Are you sure you want to remove this Document?", function () {
                    if (organizationVM.vm.SADocuments[index].DocumentID == 0 || organizationVM.vm.SADocuments[index].DocumentID == undefined)
                        organizationVM.vm.SADocuments.splice(index, 1);
                    else {
                        organizationVM.vm.SADocuments[index].DocumentID = parseInt(organizationVM.vm.SADocuments[index].DocumentID) * (-1);
                        organizationVM.tempSADocuments.push(organizationVM.vm.SADocuments[index]);
                        organizationVM.vm.SADocuments.splice(index, 1);

                    }
                });
            }

      
            function deleteSection(index, accountSectionId) {
                accountSectionId = 0;
                organizationVM.secPresent = false;
                showConfirmDialog("Confirmation", "Are you sure you want to remove this section", function () {
                //tmxNotification.set(["Are you sure you want to remove this section?"], TmxAppConstants.NOTIFICATION_WARNING, function () {

                    organizationVM.vm.TmxSurveySection[accountSectionId].SurveySectionId *= -1;
                    for (var z = 0; z < organizationVM.vm.TmxSurveySection[accountSectionId].TmxSurveySectionQuestion.length; z++) {
                        if (organizationVM.vm.TmxSurveySection[accountSectionId].TmxSurveySectionQuestion[z].SurveySectionQuestionId > -1) {
                            organizationVM.vm.TmxSurveySection[accountSectionId].TmxSurveySectionQuestion[z].SurveySectionQuestionId *= -1;
                        }

                    }

                });
            }
            setDefault();
            organizationVM.back = function () {
                $state.go("^", {}, { reload: true });
            };
            function setDefault() {
                if ($state.current.name.indexOf(".add") > 0) {
                    organizationVM.state = 'add';
                }
                else if (angular.isDefined(resolvedData.Organization) && $state.current.name.indexOf(".edit") > 0) {
                    organizationVM.state = 'edit';
                    organizationVM.vm = resolvedData.Organization.data;

                    if(resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping && resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping.length>0) {
                        for(var k=0;k<resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping.length;k++) {
                            if(organizationVM.RelationMapping && organizationVM.RelationMapping.length>0) {
                               // for (var l = 0; l < organizationVM.RelationMapping.length; l++) {
                                if (findWithAttr(organizationVM.RelationMapping, "RelationStatusLkpId", resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId) > -1) {
                                    let index = findWithAttr(organizationVM.RelationMapping, "RelationStatusLkpId", resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId);
                                    
                                    let obj = {
                                        "CustomerMasterId": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].CustomerMasterId,
                                        "RelationStatusLkpId": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId,
                                        "OrganizationID": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].OrganizationID,
                                        "CustomerToOrganizationRelationMapping": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].CustomerToOrganizationRelationMapping
                                    }
                                       
                                    organizationVM.RelationMapping[index].tempOrganizationRelationMapping.push(obj);
                                }
                                else {
                                    let tempOrganizationRelationMapping = [];
                                    let obj = {
                                        "CustomerMasterId":resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].CustomerMasterId,
                                        "RelationStatusLkpId":resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId,
                                        "OrganizationID": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].OrganizationID,
                                        "CustomerToOrganizationRelationMapping": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].CustomerToOrganizationRelationMapping
                                    }
                                    tempOrganizationRelationMapping.push(obj);
                                    var details = {
                                        "tempOrganizationRelationMapping":tempOrganizationRelationMapping,
                                        "RelationStatusLkpId":resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId
                                    }
                                    organizationVM.RelationMapping.push(details);
                                }
                                //}
                            }
                            else {
                                let tempOrganizationRelationMapping = [];
                                let obj = {
                                    "CustomerMasterId":resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].CustomerMasterId,
                                    "RelationStatusLkpId":resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId,
                                    "OrganizationID": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].OrganizationID,
                                    "CustomerToOrganizationRelationMapping": resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].CustomerToOrganizationRelationMapping
                                }
                                tempOrganizationRelationMapping.push(obj);
                                var details = {
                                    "tempOrganizationRelationMapping":tempOrganizationRelationMapping,
                                    "RelationStatusLkpId":resolvedData.Organization.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId
                                }
                                organizationVM.RelationMapping.push(details);
                            
                            }
                               
                        }
                    }
                    if (angular.isDefined(organizationVM.vm.CompanyBranchId)) {
                        organizationVM.getCompanyAndItsBranch(organizationVM.vm.CompanyBranchId);
                    }       
                    if (resolvedData.Organization.data.ActiveFlag == 1) {
                        organizationVM.vm.Status = organizationVM.StatusLkp[0].LookupId;
                    }
                    else {
                        organizationVM.vm.Status = organizationVM.StatusLkp[1].LookupId;
                    }
                }
                else {
                    organizationVM.state = 'info';
                    organizationVM.vm = resolvedData.Organization.data;
                    organizationVM.isInFoPage = true;

                }
            }
            function onBasisOfRelation(obj){
                return obj.RelationStatusLkpId;
            }
            function findWithAttr(array, attr, value) {
                for(var i = 0; i < array.length; i += 1) {
                    if(array[i][attr] === value) {
                        return i;
                    }
                }
                return -1;
            }
        
            function checkOrganizationCode(code) {

                if (angular.isDefined(code)) {

                    if (code.length < 3) {
                        return;
                    }
                    else {

                        OrganizationsService.checkOrganizationCode(code).then(function (respone) {
                            if (angular.isDefined(respone)) {

                                if (respone.status.message == "True") {

                                    organizationVM.OrganizationStatusCode = true;

                                }
                                else {

                                    organizationVM.OrganizationStatusCode = false;


                                }
                            }
                        });
                    }
                }
            }

            function setActiveFlag(value) {
                var value = lookupService.getLookupById(value).VisibleValue;
                return (value == 'ACTIVE');
            }

            function gotoAnchor() {
                $location.hash("organization-form");
                $anchorScroll();
            }

            function setTouched(form) {
                angular.forEach(form, function (value, key) {
                    if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)) {
                        value.$setTouched();
                    }
                });
            }

            function formValidation(form) {
                if (form.$invalid) {
                    setTouched(form);
                    tmxUtility.gotoAnchor(1, 'err');

                    return false;
                }
                return true;
            }

            function save(action, form) {
                organizationVM.dataLoading = true;
                organizationVM.formSubmitted = true;

                if (formValidation(form)) {
                    organizationVM.Loading = true;
                // organizationVM.vm.TmxUnitAddress = AddressDataTransformation(organizationVM.vm.TmxUnitAddress);
                    organizationVM.vm.TenantId = organizationVM.TENANTID;
                    organizationVM.vm.ActiveFlag = organizationVM.setActiveFlag(organizationVM.vm.Status);

                    if (organizationVM.tempSABankAccounts.length > 0) {
                    //organizationVM.vm.SADocuments.concat(organizationVM.tempSADocuments);
                        Array.prototype.push.apply(organizationVM.vm.TmXCustomerBankingDetails, organizationVM.tempSABankAccounts);
                    }
                    if (organizationVM.tempSAContactPersons.length > 0) {
                    //organizationVM.vm.SADocuments.concat(organizationVM.tempSADocuments);
                        Array.prototype.push.apply(organizationVM.vm.TmXOrganizationContactPersons, organizationVM.tempSAContactPersons);
                    }
                    organizationVM.vm.TmXCustomerOrganizationRelationMapping = [];
                    if (organizationVM.tempRelationMapping.length > 0) {
                    //organizationVM.vm.SADocuments.concat(organizationVM.tempSADocuments);
                        if(organizationVM.vm.TmXCustomerOrganizationRelationMapping && organizationVM.vm.TmXCustomerOrganizationRelationMapping.length>0)
                            Array.prototype.push.apply(organizationVM.vm.TmXCustomerOrganizationRelationMapping, organizationVM.tempRelationMapping);
                    }
                    if(organizationVM.RelationMapping.length>0) {
                        for(var i=0;i<organizationVM.RelationMapping.length;i++) {
                            for(var j=0;j<organizationVM.RelationMapping[i].tempOrganizationRelationMapping.length;j++) {
                                var obj = {
                                    "CustomerMasterId":organizationVM.RelationMapping[i].tempOrganizationRelationMapping[j].CustomerMasterId,
                                    "RelationStatusLkpId":organizationVM.RelationMapping[i].RelationStatusLkpId
                                }
                                organizationVM.vm.TmXCustomerOrganizationRelationMapping.push(obj);
                            }
                        }
                    }
               
                //if (organizationVM.isEdit) {
                    organizationVM.vm.$saveOrUpdate().then(function (promise) {
                        if (angular.isDefined(promise)) {

                            organizationVM.Loading = false;
                            if (promise.status.code == "200") {
                                $state.searchClear = true;
                                $state.go("^");
                            }
                        }
                    });
                // }
                // else {
                //     organizationVM.vm.$saveOrUpdate().then(function (promise) {
                //         if (angular.isDefined(promise)) {

                //             organizationVM.Loading = false;
                //             if (promise.status.code == "200") {
                //                 $state.searchClear = true;
                //                 $state.go("^");
                //             }
                //         }
                //     });
                // }
                }
                else {
                    organizationVM.dialogForm.$submitted = true;
                    if (!organizationVM.dialogForm.$valid) {
                        organizationVM.gotoAnchor();
                        return;
                    }
                }

            //if (organizationVM.OrganizationStatusCode) {

            //    showCustomToast('error', 'Organization code already exists');
            //    organizationVM.gotoAnchor();
            //    return;
            //}
            //if (organizationVM.isEdit) {
            //    if (organizationVM.vm.ParentBranchId == resolvedData.Organization.data.UnitId) {
            //        showCustomToast('error', 'Parent and Child are same');
            //        organizationVM.gotoAnchor();
            //        return;

            //    }

            //}


            // if (true || form.$invalid) {

            }


            function cancel() {

                if (!organizationVM.dialogForm.$dirty) {
                    $state.go("^", {}, { reload: true });
                    return;
                }

                $state.searchClear = true;
                showConfirmDialog("Confirmation", "Do you want to discard changes?", function () {
                    $state.go("^", {}, { reload: true });
                });
            }

        }]);
})();
